import { jsx as _jsx } from "react/jsx-runtime";
import { Collapse, Zoom } from '@mui/material';
const defaultTimeout = 250;
const inputTimeout = defaultTimeout;
const chipTimeout = 150;
export const ConditionalField = ({ show, children, timeoutComponent, timeoutMs, variant = 'collapse', }) => {
    const timeout = timeoutMs ?? (timeoutComponent === 'chip' ? chipTimeout : inputTimeout);
    if (variant === 'zoom' || variant === 'spring') {
        return (_jsx(Zoom, { in: show, timeout: timeout, 
            // easing={{
            // 	enter: 'cubic-bezier(0.0, 0, 0.2, 1)', // easeOut — fast start, slow stop
            // 	exit: 'cubic-bezier(0.4, 0, 1, 1)', // easeIn — slow start, fast finish
            // }}
            easing: variant === 'spring'
                ? {
                    enter: 'cubic-bezier(0.34, 1.56, 0.64, 1)', // "back" easing — overshoots then settles, very noticeable pop
                    exit: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)', // strong ease-in — slow start, sharp finish
                }
                : undefined, appear: false, unmountOnExit: true, mountOnEnter: true, children: _jsx("div", { children: children }) }));
    }
    return (_jsx(Collapse, { in: show, timeout: timeout, orientation: variant === 'row' ? 'horizontal' : 'vertical', appear: false, unmountOnExit: true, mountOnEnter: true, sx: {
            '& .MuiCollapse-wrapperInner': {
                opacity: show ? 1 : 0,
                transition: `opacity ${timeout}ms ease`,
            },
        }, children: children }));
};
